/**
 * Hero banner canvas (particles). Avoid forced reflow: batch DOM/layout reads
 * (e.g. getBoundingClientRect, offsetWidth) before any writes; use requestAnimationFrame
 * for visual updates so the browser can batch layout and paint.
 */
(function () {
	const canvas = document.getElementById('bg-canvas');
	if (!canvas) {
		return;
	}
	const ctx = canvas.getContext('2d', { alpha: false, desynchronized: true });
	if (!ctx) {
		return;
	}

	let particles = [];
let tick = 0;
const isMobile = window.innerWidth < 768;

const config = {
    count: isMobile ? 80 : 260, 
    speed: 2.2,
    lineDist: isMobile ? 110 : 180,
    lineDistSq: Math.pow(isMobile ? 110 : 180, 2), // Cache squared distance
    dotRadius: 1.5,
    colors: ['#12a65a', '#ff6b00']
};

function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    init();
}

window.addEventListener('resize', () => {
    clearTimeout(window.rt);
    window.rt = setTimeout(resize, 150);
});

class Particle {
    constructor() {
        this.init();
    }

    init() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.vx = (Math.random() - 0.5) * config.speed;
        this.vy = (Math.random() - 0.5) * config.speed;
        this.color = config.colors[Math.floor(Math.random() * config.colors.length)];
        this.rgb = this.color === '#12a65a' ? '18, 166, 90' : '255, 107, 0';
    }

    update() {
        this.x += this.vx;
        this.y += this.vy;

        // Fast screen wrap
        if (this.x < 0) this.x = canvas.width;
        else if (this.x > canvas.width) this.x = 0;
        if (this.y < 0) this.y = canvas.height;
        else if (this.y > canvas.height) this.y = 0;
    }

    draw() {
        ctx.fillStyle = this.color;
        ctx.beginPath();
        // 6.29 is slightly more than 2*PI, enough for a fast circle
        ctx.arc(this.x, this.y, config.dotRadius, 0, 6.29); 
        ctx.fill();
    }
}

function init() {
    particles = [];
    for (let i = 0; i < config.count; i++) {
        particles.push(new Particle());
    }
}

function animate() {
    tick++;
    // Batch drawing operations
    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const len = particles.length;
    
    for (let i = 0; i < len; i++) {
        const p1 = particles[i];
        p1.update();
        
        for (let j = i + 1; j < len; j++) {
            const p2 = particles[j];
            const dx = p1.x - p2.x;
            const dy = p1.y - p2.y;
            
            // Optimization: Manhattan distance check first (fastest)
            if (Math.abs(dx) < config.lineDist && Math.abs(dy) < config.lineDist) {
                const distSq = dx * dx + dy * dy;

                if (distSq < config.lineDistSq) {
                    const opacity = (1 - (distSq / config.lineDistSq)) * 0.5;
                    ctx.strokeStyle = `rgba(${p1.rgb}, ${opacity})`;
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.moveTo(p1.x, p1.y);
                    ctx.lineTo(p2.x, p2.y);
                    ctx.stroke();
                }
            }
        }
        p1.draw();
    }

    requestAnimationFrame(animate);
}

	resize();
	animate();
})();